// extracted by mini-css-extract-plugin
module.exports = {"blockCommon":"shop-settings-button__blockCommon___3cDbk","ShopSettingsButton":"shop-settings-button__ShopSettingsButton___3z-OR"};